import { render, staticRenderFns } from "./fivesixinfo.vue?vue&type=template&id=af862988&scoped=true&"
import script from "./fivesixinfo.vue?vue&type=script&lang=js&"
export * from "./fivesixinfo.vue?vue&type=script&lang=js&"
import style0 from "./fivesixinfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./fivesixinfo.vue?vue&type=style&index=1&id=af862988&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af862988",
  null
  
)

export default component.exports